export default __webpack_public_path__ + "db5b06e036289ce29eb31adaacd52244.svg";